import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PartnerGroup } from 'src/app/shared/models/partner-group';

@Component({
  selector: 'app-partner-group-tool-tip-modal',
  templateUrl: './partner-group-tool-tip-modal.component.html',
  styleUrls: ['./partner-group-tool-tip-modal.component.scss']
})
export class PartnerGroupToolTipModalComponent implements OnInit {

  notchTopPosition: string;
  notchLeftPosition: string;

  partnerGroup: PartnerGroup;

  constructor(public dialogRef: MatDialogRef<PartnerGroupToolTipModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private router: Router) {

      //adjust position of noth placement
      this.notchTopPosition = `${data.top - 12}px` ; //12px is the height set on the svg for the notch
      this.notchLeftPosition = `${data.left + 105}px`; //width of notch is 18px, width of modal is 210px

      this.partnerGroup = data.partnerGroup;
    }

  ngOnInit() {
  }

  onClose(){
    this.dialogRef.close();
  }

  /**
   * Takes the user to the PartnerGroup editing section
   * where splits can be adjusted
   */
  navigateToPartnerGroup(){
    this.router.navigate(['data/partners/lists/partner-groups-list', this.partnerGroup.id])

    this.onClose();
  }

}
